import type { Theme } from '@mui/material';

export const styles = {
  orgUnitSelector: {
    width: '100%',
    mb: '1.25rem',
    display: 'flex',
    alignItems: 'center',
  },
  orgUnitSelectorWrapper: {
    pt: '0.625rem',
    display: 'flex',
    flexDirection: 'column',
    pl: '0.5rem',
  },
  orgUnitSelectorLabel: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    cursor: 'pointer',
  },

  inputWrapper: {
    ml: '0.625rem',
    position: 'relative',
    flexGrow: 1,
  },

  input: {
    '& .MuiOutlinedInput-root': {
      paddingRight: '0.4rem',
    },
  },
  orgTreeIcon: (theme: Theme) => ({
    ml: '1rem',
    color: theme.colors.neutral[500],
    cursor: 'pointer',
  }),

  iconWrapper: {
    width: '2.5rem',
    display: 'flex',
    justifyContent: 'center',
  },
};
